import { selectOpenPopupBoardIds } from 'modules/overlay-v2/store/overlay/selectors';
import { PopupBoardId, usePopupRegistry } from 'modules/overlay-v2/ui/hooks/popup-registry';
import { useAppSelector } from 'store/hooks';

export interface PopupMessenger {
  /** Открыто ли хотя бы одно окно оверлея — по нему включаются кнопки синхронизации. */
  hasPopups: boolean;
  /** Отправить команду во все открытые окна: обычное и TV управляются одной панелью. */
  send: (message: object) => void;
  /** Запомнить только что открытое окно. */
  registerPopup: (boardId: PopupBoardId, popup: Window | null) => void;
}

/**
 * Связь панели управления с окнами оверлея. Команды уходят во все окна сразу, потому что
 * с одной панели открывают и оверлей для OBS, и экран в зале — раньше состояние окна
 * хранилось поштучно, и команды доставались только последнему открытому.
 *
 * Сами ссылки на окна живут в `PopupRegistryProvider`; отсюда виден только их список
 * в сериализуемом виде — по нему компоненты решают, включать ли кнопки синхронизации.
 */
function usePopupMessenger(): PopupMessenger {
  const { register, send } = usePopupRegistry();
  const openBoardIds = useAppSelector(selectOpenPopupBoardIds);

  return { hasPopups: openBoardIds.length > 0, send, registerPopup: register };
}

export default usePopupMessenger;
